/**
 * Блок «Представитель» (ТЗ п. 5.2.4).
 * Значения по умолчанию берутся из настроек приложения и могут быть
 * переопределены в конкретном деле.
 */

import { CheckboxField, InnField, TextField } from '../../../components/fields/index.js';
import type { BlockProps } from './types.js';

export function RepresentativeBlock({ profile, update, readOnly, errorFor }: BlockProps) {
  const r = profile.representative;
  const set = (patch: Partial<typeof r>) => update((p) => ({ ...p, representative: { ...p.representative, ...patch } }));

  return (
    <section className="block">
      <h2>Представитель</h2>

      <CheckboxField
        label="Заявление подаётся через представителя"
        checked={r.enabled}
        readOnly={readOnly}
        onChange={(v) => set({ enabled: v })}
      />

      {r.enabled && (
        <>
          <div className="row row-2">
            <TextField label="Наименование (ИП или организация)" value={r.name} required readOnly={readOnly} error={errorFor('representative.name')} onChange={(v) => set({ name: v })} />
            <InnField value={r.inn} readOnly={readOnly} onChange={(v) => set({ inn: v })} onResolved={(party) => set({ name: party.name, address: party.address })} />
          </div>

          <TextField label="Адрес" value={r.address} readOnly={readOnly} onChange={(v) => set({ address: v })} />

          <div className="row row-3">
            <TextField label="Телефон" value={r.phone} readOnly={readOnly} onChange={(v) => set({ phone: v })} />
            <TextField label="Электронная почта" value={r.email} readOnly={readOnly} onChange={(v) => set({ email: v })} />
            <TextField
              label="Реквизиты доверенности"
              value={r.powerOfAttorney}
              readOnly={readOnly}
              error={errorFor('representative.powerOfAttorney')}
              hint="Например: от 01.02.2026 № 66АА1234567"
              onChange={(v) => set({ powerOfAttorney: v })}
            />
          </div>
        </>
      )}
    </section>
  );
}
